<div class="existing-file-screen">
  <div class="top-text">
    <span class="lato-16-b-vw uppercase">collections overview</span>
  </div>

  <div class="entity-card">
    <div class="header">
      <div class="header-top-row">
        <span (click)="closeModal()" class="lato-16-n-vw back-button">
          < Back </span>
            <div (click)="closeModal()" class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'">
            </div>
      </div>
      <div class="header-tools">
        <span class="lato-18-n-vw existing-files">Existing Files</span>
        <div class="header-right-tools">
          <div class="header-icons">
            <div class="download-button-icon" (click)="openDownloadModal()" cygovSvgIcon
              [svgName]="'download-exfiles-icon-white'" placement="top" ngbTooltip="Download Files"
              [ngClass]="{'disable-icon': !hasSelectedFiles() || isDisabled}"></div>
            <div class="unlink-button-icon" (click)="openDeleteModal()" cygovSvgIcon
              cygovUserPermission [svgName]="'unlink-icon'" placement="top"
              ngbTooltip="Unlink Files"
              [ngClass]="{'disable-icon': !hasSelectedFiles() || isDisabled}"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="table-container">
        <table>
          <colgroup>
            <col style="width: 6%;" />
            <col style="width: 30%;" />
            <col style="width: 18%;" />
            <col style="width: 12%;" />
            <col style="width: 34%;" />
          </colgroup>
          <thead>
            <tr class="lato-16-b-vw">
              <th></th>
              <th>File Name</th>
              <th>
                <div class="upload-sort">
                  <div class="header-text">Upload Date</div>
                  <div class="sort-buttons-right">
                    <div *ngIf="sortButtons.date === 'na' || sortButtons.date === 'dsc'"
                      class="header-sort-icon" (click)="sortList('asc','date')" cygovSvgIcon
                      [svgName]="'arrow-up-type1'"></div>
                    <div *ngIf="sortButtons.date === 'na' || sortButtons.date === 'asc'"
                      class="header-sort-icon" (click)="sortList('dsc','date')" cygovSvgIcon
                      [svgName]="'arrow-down-type1'"></div>
                  </div>
                </div>
              </th>
              <th>Processed</th>
              <th>
                <div class="upload-sort">
                  <div class="header-text">User</div>
                  <div class="sort-buttons-right">
                    <div *ngIf="sortButtons.user === 'na' || sortButtons.user === 'dsc'"
                      class="header-sort-icon" (click)="sortList('asc','user')" cygovSvgIcon
                      [svgName]="'arrow-up-type1'"></div>
                    <div *ngIf="sortButtons.user === 'na' || sortButtons.user === 'asc'"
                      class="header-sort-icon" (click)="sortList('dsc','user')" cygovSvgIcon
                      [svgName]="'arrow-down-type1'"></div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="tableLoading" class="skeleton-body" aria-hidden="true">
            <tr *ngFor="let row of skeletonRows" class="table-body">
              <td class="ticked-column">
                <div class="status-circle-1"></div>
              </td>
              <td class="fileName">
                <cygov-skeleton width="12vw" height="1.2vh"></cygov-skeleton>
              </td>
              <td>
                <cygov-skeleton width="4vw" height="1.2vh"></cygov-skeleton>
              </td>
              <td>
                <cygov-skeleton shape="circle" width="2vh"></cygov-skeleton>
              </td>
              <td>
                <div class="display-user-info">
                  <cygov-skeleton shape="circle" width="4.5vh"></cygov-skeleton>
                  <div class="user-more-details">
                    <cygov-skeleton width="6vw" height="1.1vh"></cygov-skeleton>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="!tableLoading">
            <ng-container class="table-body" *ngFor="let files of filteredFiles; let i = index;">
              <tr [ngClass]="{
                'table-body': files.selected === false,
                'table-body-selected-item': files.selected === true
              }">
                <td class="ticked-column">
                  <div [ngClass]="{
                      'status-circle-1': files.selected === false,
                      'status-circle-selected-item': files.selected === true
                    }" (click)="selectedRow(i)">
                    <ng-container *ngIf="files.selected">
                      <div class="status-marker" cygovSvgIcon [svgName]="'right-tick'"></div>
                    </ng-container>
                  </div>
                </td>
                <td class="lato-14-l-vw fileName">{{ files.fileName }}</td>
                <td class="lato-14-l-vw">{{ files.uploadDate | date: 'dd.MM.yy'}} </td>
                <td class="lato-14-l-vw">
                  <div class="status-circle">
                    <div class="status-marker" cygovSvgIcon [svgName]="'right-tick'"></div>
                  </div>
                </td>
                <td>
                  <div class="display-user-info">
                    <div>
                      <cygov-username-icon [height]="'4.5'" [username]="files.userName"
                        [bgColor]="'00000'">
                      </cygov-username-icon>
                    </div>
                    <div class="lato-14-n-vw user-more-details">
                      <div class="user-full-name">{{ files.userName }}</div>

                      <div class="user-department-position"
                        *ngIf="files.userDepartment || files.userRole">
                        <div class="user-department" *ngIf="files.userDepartment">
                          {{ files.userDepartment }}
                        </div>
                        <div class="user-position" *ngIf="files.userRole">
                          {{ capitalizeFirstLetter(files.userRole) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- Separator -->
    </div>
    <div class="separator"></div>


  </div>
</div>
<div></div>
<div class="delete-modal-screen" *ngIf="deleteModalFlag">
  <div class="modal-overlay">
    <div class="modal-body">
      <div class="modal-header">
        <div (click)="closeDeleteModal()" class="close-icon" cygovSvgIcon
          [svgName]="'x-icon-type2'">
        </div>
      </div>
      <div *ngIf="this.filteredFiles.length!=0;else showNoFilesMessage"
        class="modal-delete-content">
        <div class="icon" cygovSvgIcon [svgName]="'trash-icon-3'"></div>
        <span>
          Please note you are about to delete
          <span *ngIf="!question.settings.isArtifactsMandatory">{{controlName}} control</span>
          <span *ngIf="question.settings.isArtifactsMandatory">{{controlName}} control
            MANDATORY</span>
          files
        </span>

        <div class="button-row">
          <button type="button"
            class="btn btn-primary uppercase add-entity-btn btnVendor lato-14-n-vw"
            (click)="deleteAllFiles()">
            Confirm
          </button>
          <button type="button"
            class="btn btn-primary uppercase add-entity-btn btnVendor transparent-background lato-14-n-vw"
            (click)="closeDeleteModal()">
            Cancel
          </button>
        </div>
      </div>
      <ng-template #showNoFilesMessage>
        <div class="no-files">
          <span class="lato-20-b-vw">No Files to delete</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div *ngIf="downloadModalFlag">
  <cygov-download-existing-files-modal [allFiles]="filteredFiles" [assessmentValue]="progressD"
    [controlName]="controlName" (startDownloading)="downloadFile()"
    (closeDownloadModalClicked)="closeDownloadModal($event)">
  </cygov-download-existing-files-modal>
</div>